import { Grid } from '@mui/material';
import { ISaveWorkspacePaidButNotOnboardedParam } from 'wisestep-api';
import { WsTitleBanner, WsColors } from 'wisestep-base';

import PaidButNotOnboardedCustomerDetails from './PaidButNotOnboardedCustomerDetails';

export default function PaidButNotOnboardedCustomers() {
  const query: ISaveWorkspacePaidButNotOnboardedParam = {
    id: '',
    companyName: '',
    numberOfUsersPaid: 0,
    currency: '',
    amount: 0,
    paidDate: new Date(),
    onboardedStatus: false,
    onboardedDate: new Date(),
    workspaceName: '',
    isOnboarded: 'no',
  };

  return (
    <Grid>
      <WsTitleBanner title="Paid But Not Onboarded Customers" backButton={false} />
      <Grid item xs={12} container justifyContent="center" p={2} bgcolor={WsColors.White}>
        <PaidButNotOnboardedCustomerDetails payload={query} />
      </Grid>
    </Grid>
  );
}
